module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABL0lEQVR42u3TMUpEMRAAUAsVZVnQQo9gY7Fgs7V6De1skrjJzPz43S0Wo1bWLsi/hYVnUEQEL+A5BC004/5CwmKKiYWwA8NPmJAHfyYL0gghLMZcbppmaVZyTYxohzfK4iendvQxK7lmLO2LkJj3dV13fz0HFDjLInlIjmhH18rSW6w9GTzdTqEyiKXxdy+ItgxUR7z23m8mkAxpa8/G+f6P/Z1ydMBr46pzbemsSE+Uw1dt8bYd9xVl8f0Y/F4CyRsPENamY04P7XfSllJIPl2IuKqJdg2c7PA+hQRIPrz3nWm/qss/Q9RwuK4svWigqznyTxAD1SHPPj+04kga8dBjzIkYyQX/sgQTIAJMgOQxESLH8ogcyyNyLIOUwzTQRQaRx2A02uAHPSDqSe75Am4wQ9Yd/2IQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/n-tag_2x.png
// module id = 999
// module chunks = 0